import React, { useState } from "react";
import Select from "react-select";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function Analyses() {
    const [selectedParameter, setSelectedParameter] = useState(null);
    const [searchText, setSearchText] = useState("");

    const vehicleOptions = [...Array(10).keys()].map((i) => ({
        value: `KA0${i + 1}AB1234`,
        label: `KA0${i + 1}AB1234`,
    }));

    const data = [
        { system: 1, code: "836:43:10", id: "583:37:52", dateTime: "253:05:17", occurrences: "00:00:00", info: "33,414" },
        { system: 2, code: "720:25:45", id: "500:12:30", dateTime: "220:13:15", occurrences: "05:30:10", info: "29,872" },
        { system: 3, code: "910:15:20", id: "610:40:25", dateTime: "299:35:05", occurrences: "00:45:30", info: "37,100" },
        { system: 4, code: "650:30:10", id: "430:20:15", dateTime: "210:10:55", occurrences: "10:00:00", info: "28,650" },
        { system: 5, code: "780:50:05", id: "540:15:40", dateTime: "240:34:25", occurrences: "02:15:50", info: "31,789" },
        { system: 6, code: "890:10:30", id: "600:45:50", dateTime: "289:20:10", occurrences: "00:00:00", info: "35,987" }
    ];
    
    const columns = [
        { name: "S.No", selector: (row) => row.system, sortable: true },
        { name: "Total Engine Runtime (hh:mm:ss)", selector: (row) => row.code, sortable: true },
        { name: "Time in drive mode (hh:mm:ss)" , selector: (row) => row.id, sortable: true },
        { name: "Idling without active power take-off (hh:mm:ss)", selector: (row) => row.dateTime, sortable: true },
        { name: "Idling with active power take-off (hh:mm:ss)", selector: (row) => row.occurrences, sortable: true },
        { name: "Distance Driven (Km)", selector: (row) => row.info, sortable: true },
    ];

     const handleExportPDF = () => {
        const doc = new jsPDF();
        autoTable(doc, {
            head: [columns.map((col) => col.name)],
            body: filteredData.map((row) => columns.map((col) => row[col.selector ? col.selector(row) : row[col.name]])),
        });
        doc.save("trips-data.pdf");
    };
    const customStyles = {
        headCells: {
            style: {
                backgroundColor: "#888888 ",
                color: "#ffffff",
                fontWeight: "bold",
            },
        },
    };
    const filteredData = data.filter((row) =>
        Object.values(row).some((val) =>
            val.toString().toLowerCase().includes(searchText.toLowerCase())
        )
    );

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0 font-size-18">Analyses </h4>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><a href="#/">Dashboard</a></li>
                                <li className="breadcrumb-item active">Analyses</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header p-1 pt-2">
                            <div className="row mb-3 d-flex justify-content-center">
                                <div className="col-sm-12 col-md-12 col-lg-3 mb-1">
                                    <label>Select Vehicle</label>
                                    <Select
                                        options={vehicleOptions}
                                        value={selectedParameter}
                                        onChange={setSelectedParameter}
                                        isSearchable={true} // Enables search
                                        placeholder="Select Vehicle"
                                        className="basic-single"
                                        classNamePrefix="select"
                                    />
                                </div>

                                <div className="col-sm-12 col-md-12 col-lg-2 mb-1">
                                    <label>From</label>
                                    <input type="date" className="form-control" />
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-2 mb-1">
                                    <label>To</label>
                                    <input type="date" className="form-control" />
                                </div>
                                <div className="col-md-1 mt-4">
                                    <input type="submit" value="Search" className="mt-1 btn btn-primary waves-effect waves-light" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-3">
                                <div>
                                    <CSVLink data={filteredData} filename="trips-data.csv" className="btn btn-primary btn-sm me-2">
                                        Export to CSV
                                    </CSVLink>
                                    <button onClick={handleExportPDF} className="btn btn-danger btn-sm">
                                        Export to PDF
                                    </button>
                                </div>
                                <div className="col-lg-2">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search..."
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                    />
                                </div>
                            </div>
                            <DataTable
                                columns={columns}
                                data={filteredData}
                                pagination
                                highlightOnHover
                                responsive
                                customStyles={customStyles}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
